import React, { createContext, useState } from 'react';
import axios from 'axios';
import { loadConfig } from '../config/config';

export const RegisterContext = createContext();

export const RegisterProvider = ({ children }) => {
  const [formData, setFormData] = useState({});

  const handleFormDataChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'checkbox') {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else if (type === 'file') {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // POST method for register form
  const registerCompany = async () => {
    try {
      const config = await loadConfig();
      const apiUrl = config.apiBaseUrl + '/companyInfo/create';

      // If you have file fields, use FormData:
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== undefined && value !== null) data.append(key, value);
      });

      const response = await axios.post(apiUrl, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      console.error('Registration failed:', error);
      throw error;
    }
  };

  return (
    <RegisterContext.Provider value={{
      formData,
      handleFormDataChange,
      registerCompany
    }}>
      {children}
    </RegisterContext.Provider>
  );
};